<template>
    <div class="bg-white rounded-lg shadow p-4">
        <h3 class="text-sm font-medium text-gray-700 mb-3">거래 유형</h3>
        <div class="grid grid-cols-3 gap-2">
            <button @click="toggleFilter('sell')" :class="[
                'px-3 py-1.5 text-sm font-medium rounded border transition-all',
                modelValue.sell
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'bg-white border-gray-300 text-gray-700 hover:border-gray-400',
            ]">
                <span class="flex items-center justify-center gap-1.5">
                    <svg v-if="modelValue.sell" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>매도</span>
                </span>
            </button>
            <button @click="toggleFilter('buy')" :class="[
                'px-3 py-1.5 text-sm font-medium rounded border transition-all',
                modelValue.buy
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'bg-white border-gray-300 text-gray-700 hover:border-gray-400',
            ]">
                <span class="flex items-center justify-center gap-1.5">
                    <svg v-if="modelValue.buy" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>매수</span>
                </span>
            </button>
            <button @click="toggleFilter('net')" :class="[
                'px-3 py-1.5 text-sm font-medium rounded border transition-all',
                modelValue.net
                    ? 'bg-blue-50 border-blue-500 text-blue-700'
                    : 'bg-white border-gray-300 text-gray-700 hover:border-gray-400',
            ]">
                <span class="flex items-center justify-center gap-1.5">
                    <svg v-if="modelValue.net" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>순매수</span>
                </span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DirectionFilter',
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const toggleFilter = (key) => {
            emit('update:modelValue', {
                ...props.modelValue,
                [key]: !props.modelValue[key],
            });
        };

        return {
            toggleFilter,
        };
    },
};
</script>
